__turbopack_context__.v({
  "container": "RSVPPanel-module-scss-module__XBC0ZG__container",
  "content": "RSVPPanel-module-scss-module__XBC0ZG__content",
  "ctaButtonWrapper": "RSVPPanel-module-scss-module__XBC0ZG__ctaButtonWrapper",
  "label": "RSVPPanel-module-scss-module__XBC0ZG__label",
  "secondaryRSVPButton": "RSVPPanel-module-scss-module__XBC0ZG__secondaryRSVPButton",
});
